import { render, staticRenderFns } from "./UserNextBirthdays.vue?vue&type=template&id=220ad89f&scoped=true&"
import script from "./UserNextBirthdays.vue?vue&type=script&lang=js&"
export * from "./UserNextBirthdays.vue?vue&type=script&lang=js&"
import style0 from "./UserNextBirthdays.vue?vue&type=style&index=0&id=220ad89f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ad89f",
  null
  
)

export default component.exports